/**
 * @generated SignedSource<<00546279da558b22003f8f572f568c23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackCardDeleteDraftMutation$variables = {
  id: string;
};
export type FeedbackCardDeleteDraftMutation$data = {
  readonly deleteDraftFeedback: {
    readonly deletedId: string;
  } | null;
};
export type FeedbackCardDeleteDraftMutation = {
  response: FeedbackCardDeleteDraftMutation$data;
  variables: FeedbackCardDeleteDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardDeleteDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDraftFeedback",
        "kind": "LinkedField",
        "name": "deleteDraftFeedback",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardDeleteDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDraftFeedback",
        "kind": "LinkedField",
        "name": "deleteDraftFeedback",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7a997929cf889db3f12248b90e0c121",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardDeleteDraftMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardDeleteDraftMutation(\n  $id: ID!\n) {\n  deleteDraftFeedback(id: $id) {\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "477759bfa90c49fddd498432c05e48fd";

export default node;
